import { createFileRoute } from '@tanstack/react-router'
import { loaderSeason } from '~/features/compensation/queries'
import { LedgerPage } from '~/features/finance/LedgerPage'
import { NoFinanceAccess } from '~/features/finance/parts'
import { budgetsQuery, ledgerQuery } from '~/features/finance/queries'
import { useCan } from '~/lib/session'

const UUID = /^[0-9a-f-]{36}$/i

export const Route = createFileRoute('/_app/verein/finanzen/kassenbuch')({
  // ?budget=<id>: the bookings behind a budget's actual (drill-down from /verein/budgets).
  validateSearch: (s: Record<string, unknown>): { budget?: string | undefined } => ({ budget: typeof s.budget === 'string' && UUID.test(s.budget) ? s.budget : undefined }),
  loaderDeps: ({ search }) => ({ budget: search.budget }),
  loader: async ({ context, deps }) => {
    const s = await loaderSeason(context.queryClient)
    if (!s?.canRead) return
    await Promise.all([
      context.queryClient.ensureInfiniteQueryData(ledgerQuery(s.season, deps.budget ? { budgetId: deps.budget } : {})),
      context.queryClient.ensureQueryData(budgetsQuery(s.season)),
    ])
  },
  component: function Kassenbuch() {
    const { budget } = Route.useSearch()
    return useCan()('finance.read') ? <LedgerPage budgetId={budget} /> : <NoFinanceAccess title="Finanzen" />
  },
})
